import React from 'react';
export default function TriangleLongHairTop({ light, dark }) {
  return (
<><g fill={light}><path d="M16.44 2.717c3.344 0 11.499-.204 12.115 3.638.609 3.8-3.403 9.474-3.403 9.474s-2.71-1.523-5.162-5.632c-1.956-3.277-3.55-7.48-3.55-7.48z"/><path d="M17.498 2.717c-3.343 0-10.941-.028-12.114 3.638s3.402 9.474 3.402 9.474 2.71-1.523 5.162-5.632c1.956-3.277 3.55-7.48 3.55-7.48z"/></g></>); }
